import { render, staticRenderFns } from "./Pais.vue?vue&type=template&id=b08f5cf2"
import script from "./Pais.vue?vue&type=script&lang=js"
export * from "./Pais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports